module.exports = "iframe {\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  height: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/youtube-player/youtube-player.scss
// module id = 853
// module chunks = 2